import { createSlice } from "@reduxjs/toolkit";

import {
  getCustomerSubscriptionById
} from "../actions"
import {
  getMarquetItems,
  getPlanDetails
} from "./actions"

const initialState = {
  loadedFirstTime: false,
  currencyCode: "",
  period: "",
  plans: [],
  NumberOfplansDetailsExpected: 0,
  NumberOfplansDetailsObtained: 0,
  plansDetailsObtained: false,
  plansObtained: false,
};

const chanceSubscriptionSlice = createSlice({
  name: "chanceSubscription",
  initialState: initialState,
  reducers: {
    resetChangeSubscription: () => initialState,
    resetPlan: () => initialState,
    setCurrency: (state, action) => {
      state.currencyCode = action.payload;
    },
    setPeriod: (state, action) => {
      state.period = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getMarquetItems.fulfilled,(state, action) => {
      let plans = [];
      if (action.payload.data){
        action.payload.data.map((it)=>{
          if (it.itemType === "plan" && it.price > 0 && it.status === "active"){
            plans.push(it);
          }
        })
      }
      state.plansObtained = true;
      state.loadedFirstTime = state.plansDetailsObtained ? true : false;
      state.plans = action.payload.success && plans.length > 0 ? plans: []
      state.NumberOfplansDetailsExpected = plans.length;
    });
    builder.addCase(getMarquetItems.pending, (state, action) => {});
    builder.addCase(getMarquetItems.rejected, (state, action) => {});

    builder.addCase(getCustomerSubscriptionById.fulfilled,(state, action) => {
      state.currencyCode = action.payload.success ? action.payload.data[0].currencyCode:"";
      state.period = action.payload.success ? action.payload.data[0].billingPeriodUnit.toLowerCase() : "";
    });

    builder.addCase(getPlanDetails.fulfilled, (state, action) => {
      state.plans.map((it, i)=>{
        if(it.itemId === action.payload.data.id){
          state.plans[i]["metadata"] = action.payload.data.metadata;
        }
      })
      state.NumberOfplansDetailsObtained += 1;
      state.plansDetailsObtained = state.NumberOfplansDetailsObtained === state.NumberOfplansDetailsExpected ? true : false;
      state.loadedFirstTime = state.plansDetailsObtained && state.plansObtained ? true : false;
    });
    builder.addCase(getPlanDetails.pending, (state, action) => {});
    builder.addCase(getPlanDetails.rejected, (state, action) => {});
  }
})

export const { setCurrency, setPeriod, resetChangeSubscription } = chanceSubscriptionSlice.actions;
export default chanceSubscriptionSlice.reducer;